module.exports = __webpack_public_path__ + "static/img/16一种印花机导带清洗装置.5c59a2c5.jpg";